module.exports = __webpack_public_path__ + "img/LX.520e5bb0.jpg";